import { type SVGProps } from 'react'
const Strapi = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0.243 0.265 243.323 243.581'
        {...props}
    >
        <g fill='#8e75ff' fillRule='evenodd'>
            <path d='M161.893 165.833v-78.73a5.077 5.077 0 0 0-5.077-5.076H78.178V.76h159.815a5.077 5.077 0 0 1 5.078 5.077v159.996z' />
            <path
                d='M78.178.76v81.267H3.124a2.539 2.539 0 0 1-1.796-4.333zm83.715 240.206v-75.133h81.178l-76.844 76.927a2.539 2.539 0 0 1-4.334-1.794zM78.178 82.027h81.176a2.539 2.539 0 0 1 2.539 2.538v81.268H83.255a5.077 5.077 0 0 1-5.077-5.077z'
                opacity={0.405}
            />
        </g>
    </svg>
)
export default Strapi
